import styled from "styled-components";
import colours from "../../lib/colours";

export const StyledRadioContainer = styled.div`
  display: flex;
  align-items: center;
  padding-block: 4px;
`;

export const StyledRadioInput = styled.input`
  appearance: none;
  background-color: ${colours.white};
  margin: 0;
  margin-left: 3px;
  font: inherit;
  color: currentColor;
  width: 28px;
  height: 28px;
  border: 1px solid currentColor;
  border-radius: 50%;
  display: grid;
  place-content: center;
  cursor: pointer;
  flex-shrink: 0;

  &:before {
    content: "";
    width: 16px;
    height: 16px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 16px 16px ${colours.th2};
  }

  &:checked {
    &:before {
      transform: scale(1);
    }
  }

  &:focus {
    outline: 1px solid ${colours.grey1};
  }
`;

export const StyledRadioLabel = styled.label`
  font-size: 16px;
  padding-left: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  letter-spacing: normal;
  font-weight: 400;
  color: ${colours.th1};
`;
